import { lazy, Suspense, useEffect } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'

const EventPage = lazy(async () => await import('./Views/EventPage/EventPage'))
const VenueResponsePage = lazy(
  async () => await import('./Views/VenueResponsePage/VenueResponsePage')
)

const AppRouter = (): JSX.Element => {
  const navigate = useNavigate()

  useEffect(() => {
    const redirect = (url: string): void => {
      const page = url.split('.com').pop()
      if (page) return navigate(page, { replace: false })
      return navigate(url)
    }
    window.__immutableWebAppRedirect = redirect
    return () => {
      if (window.__immutableWebAppRedirect === redirect)
        delete window.__immutableWebAppRedirect
    }
  }, [navigate])

  return (
    <Suspense fallback={<></>}>
      <Routes>
        <Route path='/responses' element={<EventPage />} />
        <Route path='/responses/:interestId' element={<VenueResponsePage />} />
      </Routes>
    </Suspense>
  )
}

export default AppRouter
